import { motion } from "framer-motion";
import { VideoCard } from "@/components/VideoTestimonials";

const EASE = [0.16, 1, 0.3, 1];

const VIDEOS = [
  {
    src: "/assets/videos/work-1.mp4",
    poster: "/assets/videos/work-1.jpg",
    title: "Deep Cleaning in Action",
    meta: "On Site · 0:39",
  },
  {
    src: "/assets/videos/work-2.mp4",
    poster: "/assets/videos/work-2.jpg",
    title: "Post-Construction Before & After",
    meta: "Transformation · 1:30",
  },
];

export default function WorkVideos() {
  return (
    <section
      id="work-videos"
      className="relative py-24 lg:py-32 bg-gradient-to-b from-[#FAFCFA] to-[#EFF8E8]/60 overflow-hidden"
      data-testid="work-videos-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: EASE }}
          className="font-mono-accent text-xs font-semibold uppercase tracking-[0.28em] text-[#4A8F2A] mb-5 text-center"
        >
          Behind the Scenes
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 26 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.85, delay: 0.1, ease: EASE }}
          className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.08] text-center max-w-3xl mx-auto"
        >
          Watch us{" "}
          <span className="font-serif-accent italic font-semibold text-[#4A8F2A]">
            work
          </span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.25 }}
          className="mt-5 text-center text-[#4A5A5E] max-w-xl mx-auto text-sm sm:text-base leading-relaxed"
        >
          No filters, no staging — real footage of Team PK transforming real
          homes.
        </motion.p>

        <div className="mt-14 grid sm:grid-cols-2 gap-8 lg:gap-14 max-w-3xl mx-auto">
          {VIDEOS.map((v, i) => (
            <VideoCard key={v.src} video={v} index={i + 2} />
          ))}
        </div>
      </div>
    </section>
  );
}
